import { useAppContext } from 'contexts/AppContext';
import { useMemo } from 'react';
import ReactLoading from 'react-loading';
import themeVariables from '../../config/theme';

interface ILoadingProps {
  size?: number;
  color?: string;
}

const themeToLoadingColor: Record<string, string> = {
  primary: themeVariables.primaryColor,
  green: themeVariables.successColor,
};

const Loading = ({ size, color }: ILoadingProps) => {
  const { theme } = useAppContext();
  const spinnerColor = useMemo(
    // Bug: the last fallback read `theme.primaryColor`, but `theme` is the theme name (a string),
    // so it is always undefined; an unknown theme gets react-loading's default colour.
    () => color || themeToLoadingColor[theme] || undefined,
    [color, theme],
  );
  return <ReactLoading type="spin" color={spinnerColor} height={size} width={size} />;
};

export default Loading;
